import { useCheckoutState, useIsAfterpayAppGiftCardFlow, useRegionHasMultiTenant } from '../../state'
import { CheckoutStatus } from '../../model'
import { Route } from '../../config/router'
import { useRouter } from 'next/router'

export const useHideFooterForUSLoginPage = (): boolean => {
  const { pathname } = useRouter()
  const regionHasMultiTenant = useRegionHasMultiTenant()

  const isLoginRoute = pathname === Route.ENTER_EMAIL
  return isLoginRoute && regionHasMultiTenant
}

export const useAllowClose = (allowClose: boolean): boolean => {
  const { status } = useCheckoutState()
  const isAfterpayAppGiftCardFlow = useIsAfterpayAppGiftCardFlow()
  const router = useRouter()

  const { asPath } = router
  const isPurchseSuccessRoute = asPath === Route.PURCHASE_SUCCESS

  const isNotConfirmingOrConfirmed = status !== CheckoutStatus.Confirming && status !== CheckoutStatus.Confirmed
  const shouldAllowClose = isNotConfirmingOrConfirmed && !isAfterpayAppGiftCardFlow

  return allowClose && (shouldAllowClose || isPurchseSuccessRoute)
}
